module.exports = __webpack_public_path__ + "static/media/scrumweb.64b80878.svg";